/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Attribute } from './attribute';
import { BusinessObjectDataKey } from './businessObjectDataKey';
import { StorageUnitCreateRequest } from './storageUnitCreateRequest';


export interface BusinessObjectDataCreateRequest { 
    /**
     * The Namespace to which a Business Object Format is related
     */
    namespace: string;
    /**
     * The name of the Business Object Definition to which a Business Object Format is related
     */
    businessObjectDefinitionName: string;
    /**
     * The Usage of this Business Object Format - a string describing how this format is used. Often used as a label for the Business                   Object Format. Does not have to be unique in the system, the Usage string is frequently shared across formats for multiple Business Object                   Definitions                
     */
    businessObjectFormatUsage: string;
    /**
     * A File Type known to the system that describes the file type of data stored under a Business Object Format
     */
    businessObjectFormatFileType: string;
    /**
     * The Business Object Format Version for a previously registered Business Object Format
     */
    businessObjectFormatVersion?: number;
    /**
     * The Partition Key this Business Object Data is being registered with. This must be they Partition Key specified in the Business                   Object Format                
     */
    partitionKey: string;
    /**
     * The Partition Value that this Business Object Data is associated with
     */
    partitionValue: string;
    /**
     * A list of Sub-Partition values associated with this Business Object Data
     */
    subPartitionValues?: Array<string>;
    /**
     * The status of the Business Object Data. One of the following values: VALID, UPLOADING, PENDING_VALID, PROCESSING, INVALID,                   ARCHIVED, EXPIRED, or DELETED. Pre-registration status include UPLOADING, PENDING_VALID, and PROCESSING. Defaults to VALID if value is not                   provided                
     */
    status?: string;
    /**
     * A container for Storage Units that contain data associated with the Business Object Data being registered
     */
    storageUnits?: Array<StorageUnitCreateRequest>;
    /**
     * Collection of name-value pairs. This can be used to store things such as S3 bucket names, validation flags, and custom                   user-defined meta-data about this storage. Attributes values are required for certain keys that are defined as Attribute Definitions in the                   Business Object Format                
     */
    attributes?: Array<Attribute>;
    /**
     * An optional list of Business Object Data parents (i.e. predecessors) that were used/needed in the creation of this data. This                   is used for data lineage. Each parent consists of the key data that uniquely defines a reference to a single Business Object Data.                
     */
    businessObjectDataParents?: Array<BusinessObjectDataKey>;
    /**
     * If true, a new Business Object Data Version will be created and registered that supercedes a previous version. If false, then                   only an initial Business Object Data Version (version 0) is allowed to be registered                
     */
    createNewVersion?: boolean;
}
